"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getUserCheck = void 0;
var _constants = require("../constants");
var _cookies = require("./cookies");
var _hashes = require("./hashes");
/**
 * Returns user check hash data based on user cookie.
 * The cookie should always be set at least in Online session.
 * The 'unknown' value is just a fallback for testing.
 */
const getUserCheck = () => (0, _hashes.adler32)(((0, _cookies.getCookie)(_constants.USER_COOKIE_NAME) ?? '').trim() || 'unknown');
exports.getUserCheck = getUserCheck;